import HomePage from "@/pages/home.page";
import MemoriesPage from "@/pages/memories.page";
import ArticlePage from "@/pages/article.page";
import GTAPage from "@/pages/gta.page";
import JuryPage from "@/pages/jury.page";
import ChatTestPage from "@/pages/chat-test.page";
import SocialsPage from "@/pages/socials.page";
import SupportPage from "@/pages/support.page";
import RegistrationPage from "@/pages/registration.page";
import RegistrationPageHowToBuild from "@/pages/registration-how-to-build.page";
import RegistrationPageGS from "@/pages/registration-gs.page";

const routes = [
  {
    name: "home",
    path: "/",
    component: HomePage
  },
  {
    name: "memories",
    path: "/birthday",
    component: MemoriesPage
  },
  {
    name: "article",
    path: "/article/:id-:title",
    component: ArticlePage
  },
  {
    name: "jury",
    path: "/jury",
    component: JuryPage
  },
  {
    name: "gta",
    path: "/gta",
    component: GTAPage
  },
  {
    name: "socials",
    path: "/socials",
    component: SocialsPage
  },
  {
    name: "chat-test",
    path: "/chat-test",
    component: ChatTestPage
  },
  {
    name: "support",
    path: "/support",
    component: SupportPage
  },
  {
    name: "registration",
    path: "/resumesandreels",
    component: RegistrationPage
  },
  {
    name: "registration-how-to-build",
    path: "/howtobuildyourcareer",
    component: RegistrationPageHowToBuild
  },
  {
    name: "registration-gs",
    path: "/communicatingwithimpact",
    component: RegistrationPageGS
  },
  {
    name: "authenticate",
    path: "/authenticate",
    beforeEnter(to) {
      localStorage.setItem("token", to.query.token);
    }
  }
];

export default routes;
